import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    cashLimitUploadEventsType,
    sortingParamType,
} from '../../types';
import CashLimitUploadEventRow from './CashLimitUploadEventRow';
import SortControl from '../SortControl';

CashLimitUploadEventsList.propTypes = {
    cashLimitUploadEvents: cashLimitUploadEventsType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function CashLimitUploadEventsList(props) {
    const {
        cashLimitUploadEvents,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="cash-limit-upload-events-list">
            <div className="rich-list-row rich-list-header cash-limit-upload-events-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="cash-limit-upload-event-header--values--timestamp">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="uploadTimestamp">
                        {t('cash-limit-upload-events.list-header.timestamp')}
                    </SortControl>
                </div>
                <div className="cash-limit-upload-event-header--values--filename">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="fileName">
                        {t('cash-limit-upload-events.list-header.filename')}
                    </SortControl>
                </div>
                <div className="cash-limit-upload-event-header--values--export-timestamp">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="exportTimestamp">
                        {t('cash-limit-upload-events.list-header.export-timestamp')}
                    </SortControl>
                </div>
                <div className="cash-limit-upload-event-header--values--uploader">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="uploader">
                        {t('cash-limit-upload-events.list-header.uploader')}
                    </SortControl>
                </div>
                <div className="cash-limit-upload-event-header--values--outcome">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="outcome">
                        {t('cash-limit-upload-events.list-header.outcome')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                cashLimitUploadEvents.length
                    ? cashLimitUploadEvents.map((cashLimitUploadEvent) => (
                        <CashLimitUploadEventRow
                            cashLimitUploadEvent={cashLimitUploadEvent}
                            key={cashLimitUploadEvent.id}
                        />
                    ))
                    : (
                        <div className="cash-limit-upload-events-no-items">
                            {t('cash-limit-upload-events.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default CashLimitUploadEventsList;
